<script>
  import Footer from "../Components/Footer.svelte";
  import Gallery from "../Components/Gallery.svelte";
  import Title from "../Components/Title.svelte";
  import { useFocus } from "svelte-navigator";
  const focus = useFocus();

  const images = [
    {
      src: "ben_hogue.webp",
      alt: "Ben Hogue playing pedal steel",
    },
    {
      src: "ernie.webp",
      alt: "Ernie playing drums",
    },
    {
      src: "ben1.webp",
      alt: "Ben Noblit playing upright bass",
    },
    {
      src: "ben_hogue2.webp",
      alt: "Ben Hogue playing pedal steel",
    },
    {
      src: "zach.webp",
      alt: "Zach White playing guitar",
    },
    {
      src: "zach2.webp",
      alt: "Zach White playing guitar",
    },
    {
      src: "ernie2.webp",
      alt: "Ernie playing drums",
    },
    {
      src: "guitar.webp",
      alt: "Guitar being fretted",
    },
    {
      src: "ernie3.webp",
      alt: "Ernie playing drums and singing",
    },
    {
      src: "ben2.webp",
      alt: "Ernie playing drums and Ben playing upright bass",
    },
    {
      src: "ben_hogue1.webp",
      alt: "Close up of Ben Hogue playing pedal steel",
    },
    {
      src: "ben_hogue3.webp",
      alt: "Close up of Ben Hogue playing pedal steel",
    },
    {
      src: "ben3.webp",
      alt: "Ben Noblit playing upright bass",
    },
    {
      src: "ben4.webp",
      alt: "Ben Noblit playing electric bass",
    },
    {
      src: "band2.webp",
      alt: "Zach playing guitar in the foreground with Ben and Ernie",
    },
    {
      src: "band3.webp",
      alt: "Zach and the two Bens jamming",
    },
    {
      src: "band4.webp",
      alt: "The two Bens playing pedal steel and electric bass",
    },
    {
      src: "zach3.webp",
      alt: "Zach singing and playing guitar",
    },
    {
      src: "band5.webp",
      alt: "Side shot of the two Bens playing pedal steel and electric bass",
    },
    {
      src: "band6.webp",
      alt: "The two Bens and Ernie jamming",
    },
    {
      src: "ernie4.webp",
      alt: "Ernie playing drums",
    },
    {
      src: "zach4.webp",
      alt: "Zach singing and playing guitar",
    },
  ];
</script>

<svelte:head>
  <meta
    name="description"
    content="Discover Country Cruel, a small town North Carolina country band. We play exciting, upbeat music perfect to dance to! Find us on Spotify, Youtube and Soundcloud."
  />
  <title>Pictures of Country Cruel - Hard hitting country music</title>
</svelte:head>
<h2 use:focus>Media</h2>
<main>
  <Gallery {images} maxWidth="90rem" slideDuration={5000} />
  <Title />
</main>
<Footer />
